import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div(props => ({
    whiteSpace: "normal",
    fontWeight: "bold",
    fontSize: "20px",
    color: theme(props).typography.primary.color,
    lineHeight: "28px",
    textAlign: "left",
    marginBottom: 20,
}));
